import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { ProjectStore } from "../_models/project-store.interface";

@Injectable({
  providedIn: 'root'
})
export class ProjectStoreService {

  constructor(private http: HttpClient) {
  }

  public createProjectStore(project_store: ProjectStore) {
    const path = environment.apiURL + `projects_stores`

    return this.http.post<ProjectStore>(path, { project_store })
  }

  public deleteProjectStore(project_id: number, store_id: number) {
    const path = environment.apiURL + `projects_stores/${project_id}/${store_id}`

    return this.http.delete<void>(path)
  }
}
